import agent from "../../../assets/agent-tabs.png";

const Owner = () => {
  return (
    <div>
      <div className="lg:flex items-center justify-center my-20 px-6 lg:px-[200px]">
        <div className="max-lg:hidden">
          <img alt="driver" src={agent} className="w-[50%] mx-auto" />
        </div>
        <div className="space-y-10">
          <div>
            <h1 className="text-xl lg:text-3xl my-3 font-semibold text-primaryBlack">
              Point of sale (POS)
            </h1>
            <span>
              We strive to make the transportation process as smooth and
              stress-free as possible, whether you're a business owner trying to
              get your products to customers,{" "}
            </span>
          </div>
          <div>
            <h1 className="text-xl lg:text-3xl my-3 font-semibold text-primaryBlack">
              Point of sale (POS)
            </h1>
            <span>
              We strive to make the transportation process as smooth and
              stress-free as possible, whether you're a business owner trying to
              get your products to customers,{" "}
            </span>
          </div>
          <div>
            <h1 className="text-xl lg:text-3xl my-3 font-semibold text-primaryBlack">
              Point of sale (POS)
            </h1>
            <span>
              We strive to make the transportation process as smooth and
              stress-free as possible, whether you're a business owner trying to
              get your products to customers,{" "}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Owner;
